import React from "react";
import { motion, useReducedMotion } from "framer-motion";

export default function MotionReveal({ children, className = "", delay = 0, y = 28 }) {
  const prefersReducedMotion = useReducedMotion();
  const resolvedClassName = `public-home-premium__motion-reveal ${className}`.trim();

  if (prefersReducedMotion) {
    return <div className={resolvedClassName}>{children}</div>;
  }

  return (
    <motion.div
      className={resolvedClassName}
      initial={false}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.24 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
